import { all, fork } from 'redux-saga/effects'

import getCMSsaga from './sagas/getCMSsaga'

function* CMSSaga() {
  yield all([fork(getCMSsaga)])
}

export default CMSSaga
